import { createAction } from 'redux-actions';

import types from './types';

const getStores = createAction(types.GET_STORES);
const getStoresLetters = createAction(types.GET_STORES_LETTERS);
const getSuggestedStores = createAction(types.GET_SUGGESTED_STORES);
const setStoresData = createAction(types.SET_STORES_DATA);

const selectStore = createAction(types.SELECT_STORE);
const unselectStore = () => createAction(types.SELECT_STORE)(false);
const setErrorState = createAction(types.SET_ERROR_STATE);
const setErrorType = createAction(types.SET_ERROR_TYPE);
const resetErrors = createAction(types.RESET_ERROR);
const setQueryValue = createAction(types.SET_QUERY_VALUE);
const setCurrentPage = createAction(types.SET_CURRENT_PAGE);

const loadGoogleMapsApi = createAction(types.LOAD_GOOGLE_MAPS_API);
const setGoogleMapsApiLoaded = () => createAction(types.SET_GOOGLE_MAPS_API_LOADED)(true);

const saveAPIParameters = createAction(types.SAVE_API_PARAMETERS);
const getStoresByTown = createAction(types.GET_STORES_BY_TOWN);

const setPickUpExpressStoreID = createAction(types.SET_PICK_UP_EXPRESS_STOREID);
export default {
    getStores,
    getSuggestedStores,
    setStoresData,
    getStoresLetters,
    selectStore,
    unselectStore,
    setErrorState,
    setErrorType,
    setQueryValue,
    loadGoogleMapsApi,
    setGoogleMapsApiLoaded,
    saveAPIParameters,
    getStoresByTown,
    setCurrentPage,
    setPickUpExpressStoreID,
    resetErrors,
};
